import { hbs } from 'ember-cli-htmlbars';
export default hbs("<NwPageContent class=\"nw-page-content--single nw-settings\">\n  <Settings::SettingsBody @user={{@user}}>\n    {{yield}}\n  </Settings::SettingsBody>\n</NwPageContent>")